import React from 'react'
import styled from 'styled-components'

import Avatar from '../Avatar'
import LazyImage from '../LazyImage'

type Options = {
  avatarSize?: number
  $rightAlign?: boolean
}

const StackedAvatar = styled(Avatar)<{ offset: number } & Options>`
  border: 2px solid ${({ theme }) => theme['-ds-neutral-200'].value};
  margin-right: 0;
  flex-shrink: 0;

  ${({ avatarSize }) =>
    avatarSize &&
    `
    width: ${avatarSize}px;
    height: ${avatarSize}px;
  `}

  &:not(:first-child) {
    ${({ offset }) => `
        transform: translateX(${offset}px);
    `}
  }
`

const Outer = styled.div<Options>`
  display: flex;
  overflow: hidden;

  ${({ $rightAlign }) =>
    $rightAlign &&
    `
    flex-direction: row-reverse;
  `}
`

type AvatarStackProps = {
  urls: string[]
} & Options

const AvatarStack = ({ urls, avatarSize, $rightAlign }: AvatarStackProps) => {
  return (
    <Outer $rightAlign={$rightAlign}>
      {urls.map((url, index) => {
        const baseOffset = $rightAlign ? 20 : -20
        const offset = baseOffset * index + 1
        return (
          <StackedAvatar
            key={url}
            offset={offset}
            avatarSize={avatarSize}
            $rightAlign={$rightAlign}
          >
            <LazyImage data-src={url} />
          </StackedAvatar>
        )
      })}
    </Outer>
  )
}

export default AvatarStack
